<c-sidebar
  #sidebar="cSidebar"
  id="sidebar"
  style="background-color: #0d0d0d; width: 280px"
  visible
  (visibleChange)="handleVisible($event)"
>
  <ng-scrollbar pointerEventsMethod="scrollbar">
    <c-sidebar-nav>
      <div class="sidebar-content">
        <div *ngFor="let item of navItems">
          <div
            *ngIf="!item.children"
            class="nav-item"
            [ngClass]="{ active: item.name === activeParent }"
            (click)="toggleParent(item.name); navigateTo(item.url)"
          >
            <img src="{{ item.icon }}" (error)="onImageError($event)" />
            <span>{{ item.name }}</span>
            <span *ngIf="item?.badge" class="count-badge">
              <div>
                {{ item?.badge?.text || "0" }}
              </div>
            </span>
          </div>

          <div *ngIf="item.children" (click)="toggleDropdown(item)">
            <div class="nav-item" [ngClass]="{ active: item.expanded }">
              <img src="{{ item.icon }}" (error)="onImageError($event)" />
              <span>{{ item.name }}</span>
            </div>
            <div *ngIf="item.expanded">
              <div
                *ngFor="let child of item.children"
                class="nav-item sub-item"
                style="margin-top: 10px"
                [ngClass]="{ active: child.name === activeChild }"
                (click)="
                  toggleParentChild(child.name);
                  navigateTo(child.url);
                  $event.stopPropagation()
                "
              >
                <img src="assets/images/Vector.svg" />
                <span>{{ child.name }}</span>
                <span *ngIf="child?.badge" class="count-badge">
                  <div>
                    {{ child?.badge?.text || "0" }}
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </c-sidebar-nav>
  </ng-scrollbar>
</c-sidebar>
<app-loader></app-loader>
<div
  class="wrapper d-flex flex-column min-vh-100 dark:bg-transparent main-section-body"
>
  <app-header
    *ngIf="!isWebView"
    class="d-print-none header header-sticky"
    position="sticky"
    sidebarId="sidebar"
  />
  <div class="body flex-grow-1 px-3" style="background-color: #f8f8f8">
    <router-outlet></router-outlet>
  </div>
</div>
